<template>
	<HelpBox :backgroundUrl="backgroundUrl" @click="askCommunityForHelp">
		<template #text>
			<span> Ask for help<br />from the community </span>
		</template>
	</HelpBox>
</template>

<script>
import InAppHelpMenuService from '@/components/InAppHelp/in-app-help-menu-service';
import HelpBox from './HelpBox.vue';
import backgroundUrl from './assets/ply-community.png';

export default {
	name: 'AskCommunityHelpBox',
	components: { HelpBox },
	methods: {
		askCommunityForHelp() {
			InAppHelpMenuService.openCommunity();
			this.$emit('click');
		},
	},
	data() {
		return {
			backgroundUrl,
		};
	},
};
</script>

<style lang="scss" scoped></style>
